/**
 * avv.js — Generator für einen Muster-Auftragsverarbeitungsvertrag (AVV) nach Art. 28 DSGVO.
 *
 * Befüllt aus data/company.js. Bewusst als MUSTER gekennzeichnet — der Owner muss es vor
 * Verwendung prüfen/anpassen (Owner-Direktive: in-house, Eigenrecherche + Disclaimer).
 * Stellt keine Rechtsberatung dar.
 */
import { company, addressLines } from "./company";

export function buildAvvText(customerName = "____________________") {
  const anbieter = addressLines().join(", ");
  const today = new Date().toLocaleDateString("de-DE");
  return `AUFTRAGSVERARBEITUNGSVERTRAG (AVV) nach Art. 28 DSGVO
— MUSTER, vor Verwendung rechtlich zu prüfen —

Stand: ${today}

§ 1 Vertragsparteien
Verantwortlicher (Auftraggeber):
  ${customerName}

Auftragsverarbeiter (Anbieter):
  ${anbieter}
  E-Mail: ${company.privacyEmail || company.email}

§ 2 Gegenstand und Dauer
Gegenstand ist die Verarbeitung personenbezogener Daten durch den Anbieter im Rahmen der
Bereitstellung des Dienstes "${company.productName}" (Social-Media-Management). Die Dauer
entspricht der Laufzeit des Hauptvertrags (Abonnement).

§ 3 Art, Umfang, Zweck der Verarbeitung
Verarbeitet werden insbesondere: Kontaktdaten der Nutzer des Auftraggebers, von den verbundenen
Social-Media-Konten abgerufene Inhalte (z. B. Kommentare, Nachrichten, Profilangaben) sowie zur
Veröffentlichung erstellte Inhalte. Zweck ist ausschließlich die vertragsgemäße Diensterbringung.

§ 4 Betroffene Personen
Endkunden/Interessenten des Auftraggebers sowie Personen, die mit dessen Social-Media-Konten
interagieren.

§ 5 Pflichten des Auftragsverarbeiters
(1) Verarbeitung nur auf dokumentierte Weisung des Auftraggebers.
(2) Vertraulichkeit der zur Verarbeitung befugten Personen (Art. 28 Abs. 3 lit. b).
(3) Technische und organisatorische Maßnahmen nach Art. 32 (siehe § 7).
(4) Unterstützung des Auftraggebers bei Betroffenenrechten (Auskunft, Löschung, Datenexport) —
    der Dienst stellt hierfür Selbstbedienungs-Funktionen bereit (Datenexport Art. 20,
    Löschung Art. 17).
(5) Unterstützung bei Meldepflichten (Art. 33/34).
(6) Löschung oder Rückgabe der Daten nach Vertragsende.
(7) Nachweis der Einhaltung; Ermöglichung von Überprüfungen.

§ 6 Unterauftragsverarbeiter (Subprozessoren)
Der Auftraggeber stimmt dem Einsatz folgender Subprozessoren zu: Hosting/Infrastruktur (EU),
KI-Anbieter zur Text- und Medienerstellung (derzeit: Anthropic PBC (USA), Groq, Inc. (USA) sowie fal.ai /
Features & Labels, Inc., USA), Zahlungsabwicklung (Stripe Payments Europe Ltd., IE /
Stripe, Inc., USA), Transaktions-E-Mails (Resend, USA) sowie die jeweils vom Auftraggeber
verbundenen Social-Media-Plattformen (Meta/Facebook/Instagram/Threads, LinkedIn, TikTok,
Pinterest, Bluesky). Änderungen der Liste werden vorab angekündigt. Datenübermittlungen in Drittländer erfolgen nur auf
Grundlage geeigneter Garantien (Art. 46, z. B. EU-Standardvertragsklauseln).

§ 7 Technische und organisatorische Maßnahmen (Art. 32)
- Verschlüsselung gespeicherter Zugangs-/OAuth-Tokens (at rest).
- Mandantentrennung: strikte Isolation der Daten je Kundenkonto.
- Zugriffskontrolle: Authentifizierung (JWT), Rollen-/Rechtekonzept, Master-/Inhaber-Trennung.
- Transportverschlüsselung (TLS/HTTPS).
- Protokollierung sicherheitsrelevanter Ereignisse; Fehler-Monitoring.
- Betroffenenrechte per Self-Service (Export/Löschung).

§ 8 Haftung und Schlussbestimmungen
Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen unwirksam sein,
bleibt der übrige Vertrag wirksam.

Ort, Datum: ________________________

Auftraggeber: ______________________      Auftragsverarbeiter: ______________________

--------------------------------------------------------------------------------
HINWEIS: Dies ist ein generiertes MUSTER und ersetzt keine Rechtsberatung. Vor dem
produktiven Einsatz durch den Anbieter zu prüfen und ggf. anzupassen.`;
}
